export const defaultLang = 'en';
